import { PopupMenu } from './PopupMenu';
import { isPrintableCharacter, keyCode } from './helpers';

export class MenubarItem {
    constructor(domNode, menuObj) {
        this.menu = menuObj;
        this.domNode = domNode;
        this.popupMenu = false;
        this.hasFocus = false;
        this.hasHover = false;
        this.isMenubarItem = true;
        this.keyCode = keyCode;
    }

    init() {
        this.domNode.addEventListener('keydown', this.handleKeydown.bind(this));
        this.domNode.addEventListener('focus', this.handleFocus.bind(this));
        this.domNode.addEventListener('blur', this.handleBlur.bind(this));

        // Since css hover rule is set for element li, it is necessary to add event handler for element li
        this.domNode.parentNode.addEventListener('mouseover', this.handleMouseover.bind(this));
        this.domNode.parentNode.addEventListener('mouseout', this.handleMouseout.bind(this));

        // Initialize pop up menus
        let nextElement = this.domNode.nextElementSibling;
        let hasSubMenu = nextElement && nextElement.classList.contains('js-header-sub-menu');

        if (hasSubMenu) {
            this.popupMenu = new PopupMenu(nextElement, this);
            this.popupMenu.init();
        }
    }

    handleKeydown() {
        let char = event.key,
            isMenuOpen = false;

        switch (event.keyCode) {
            case this.keyCode.SPACE:
            case this.keyCode.RETURN:
            case this.keyCode.DOWN:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToFirstItem();
                    isMenuOpen = true;
                }
                break;

            case this.keyCode.LEFT:
                this.menu.setFocusToPreviousItem(this);
                isMenuOpen = true;
                break;

            case this.keyCode.RIGHT:
                this.menu.setFocusToNextItem(this);
                isMenuOpen = true;
                break;

            case this.keyCode.UP:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToLastItem();
                    isMenuOpen = true;
                }
                break;

            case this.keyCode.HOME:
            case this.keyCode.PAGEUP:
                this.menu.setFocusToFirstItem();
                isMenuOpen = true;
                break;

            case this.keyCode.END:
            case this.keyCode.PAGEDOWN:
                this.menu.setFocusToLastItem();
                isMenuOpen = true;
                break;

            case this.keyCode.TAB:
                if (this.popupMenu) {
                    this.popupMenu.close(true);
                }

                break;

            case this.keyCode.ESC:
                this.popupMenu.close(true);
                break;

            default:
                if (isPrintableCharacter(char)) {
                    this.menu.setFocusByFirstCharacter(this, char);
                    isMenuOpen = true;
                }
                break;
        }

        if (isMenuOpen) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    setExpanded(value) {
        this.domNode.setAttribute('aria-expanded', value ? 'true' : 'false');
    }

    handleFocus() {
        this.menu.hasFocus = true;
    }

    handleBlur() {
        this.menu.hasFocus = false;
    }

    handleMouseover() {
        this.hasHover = true;

        if (this.popupMenu) {
            this.popupMenu.open();
        }
    }

    handleMouseout() {
        this.hasHover = false;

        if (this.popupMenu) {
            setTimeout(this.popupMenu.close.bind(this.popupMenu, false), 0);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/organisms/header/scripts/a11y-navigation/MenubarItem.js